const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m4-1.75a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zm0 12a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5zM8.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m1 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/></svg>';
export {
  a as w
};
